module.exports = __webpack_public_path__ + "static/media/GP.43fad009.svg";